import styled from 'styled-components';
import {MediaQuery, responsiveSizesMap} from '../lib/responsive';

interface EllipsizeProps {
  maxWidth?: string | Partial<MediaQuery<string>>;
  minWidth?: string | Partial<MediaQuery<string>>;
}

const EllipsizedContainer = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: initial;
  white-space: nowrap;
  max-width: ${(props: EllipsizeProps) => {
    return typeof props.maxWidth === 'string' ? props.maxWidth : '';
  }};
  min-width: ${(props: EllipsizeProps) => {
    return typeof props.minWidth === 'string' ? props.minWidth : '';
  }};
  @media (max-width: ${responsiveSizesMap.xl}px) {
    max-width: ${(props: EllipsizeProps) => (props.maxWidth as Partial<MediaQuery<string>>)?.xl};
    min-width: ${(props: EllipsizeProps) => (props.minWidth as Partial<MediaQuery<string>>)?.xl};
  }
  @media (max-width: ${responsiveSizesMap.lg}px) {
    max-width: ${(props: EllipsizeProps) => (props.maxWidth as Partial<MediaQuery<string>>)?.lg};
    min-width: ${(props: EllipsizeProps) => (props.minWidth as Partial<MediaQuery<string>>)?.lg};
  }
  @media (max-width: ${responsiveSizesMap.md}px) {
    max-width: ${(props: EllipsizeProps) => (props.maxWidth as Partial<MediaQuery<string>>)?.md};
    min-width: ${(props: EllipsizeProps) => (props.minWidth as Partial<MediaQuery<string>>)?.md};
  }
  @media (max-width: ${responsiveSizesMap.sm}px) {
    max-width: ${(props: EllipsizeProps) => (props.maxWidth as Partial<MediaQuery<string>>)?.sm};
    min-width: ${(props: EllipsizeProps) => (props.minWidth as Partial<MediaQuery<string>>)?.sm};
  }
  @media (max-width: ${responsiveSizesMap.xs}px) {
    max-width: ${(props: EllipsizeProps) => (props.maxWidth as Partial<MediaQuery<string>>)?.xs};
    min-width: ${(props: EllipsizeProps) => (props.minWidth as Partial<MediaQuery<string>>)?.xs};
  } ;
`;

/*
  This component is used to ellipsize text in a cell.
  it takes a maxWidth prop that can be a string or a MediaQuery object.
  example: <Ellipsize maxWidth={{xl: '90ch', md: '25ch', sm: '15ch'}}>{text}</Ellipsize>
  or: <Ellipsize maxWidth="90ch">{text}</Ellipsize>
  ch unit represents characters.
 */
export const Ellipsize: React.FC<EllipsizeProps> = (props) => {
  return <EllipsizedContainer {...props}>{props.children}</EllipsizedContainer>;
};
